// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__OIIaW","btnOffer":"AddProduct_btnOffer__4KeLY"};